import { useState } from "react";

const VOWELS = [
  { letter: "A", word: "Apple", emoji: "🍎", color: "from-berry-light to-rust-dark" },
  { letter: "E", word: "Egg", emoji: "🥚", color: "from-gold-500 to-gold-600" },
  { letter: "I", word: "Ice cream", emoji: "🍦", color: "from-sky to-sky-dark" },
  { letter: "O", word: "Orange", emoji: "🍊", color: "from-gold-500 to-berry-light0" },
  { letter: "U", word: "Umbrella", emoji: "☂️", color: "from-gold-300 to-gold-600" },
];

function speak(text) {
  if ("speechSynthesis" in window) {
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = "en-US";
    u.rate = 0.8;
    window.speechSynthesis.speak(u);
  }
}

export default function VowelChart() {
  // eslint-disable-next-line no-unused-vars
  const [hovered, setHovered] = useState(null);

  return (
    <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-5">
      <div className="text-center mb-4">
        <p className="text-xs font-bold uppercase tracking-wider text-white/60 mb-1">The 5 Magic Vowels</p>
        <h3 className="text-2xl font-black">A · E · I · O · U → use "an"</h3>
        <p className="text-sm text-white/70 mt-2">Anything else (B, C, D, F, G…) → use "a"</p>
      </div>

      <div className="grid grid-cols-5 gap-2 mb-5">
        {VOWELS.map((v, i) => (
          <button
            key={v.letter}
            onClick={() => speak(`an ${v.word}`)}
            onMouseEnter={() => setHovered(i)}
            onMouseLeave={() => setHovered(null)}
            className={`group relative aspect-square rounded-2xl bg-gradient-to-br ${v.color} flex flex-col items-center justify-center text-white font-black shadow-lg hover:scale-110 hover:rotate-6 transition-transform`}
          >
            <span className="text-3xl md:text-4xl">{v.letter}</span>
            <span className="text-xl mt-1 group-hover:scale-125 transition-transform">{v.emoji}</span>
            <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 text-[9px] uppercase tracking-wider text-white/90 whitespace-nowrap font-bold">
              an {v.word}
            </span>
          </button>
        ))}
      </div>

      {/* Compare table */}
      <div className="bg-black/20 rounded-2xl p-4 mt-6">
        <p className="text-xs uppercase tracking-wider font-bold text-white/60 mb-3">Compare:</p>
        <div className="grid grid-cols-2 gap-3 text-sm">
          <div>
            <p className="font-bold text-gold-300 mb-1">A → consonant sound</p>
            <ul className="space-y-0.5 text-white/80 text-xs">
              <li>• <strong>a</strong> banana 🍌</li>
              <li>• <strong>a</strong> dog 🐶</li>
              <li>• <strong>a</strong> kite 🪁</li>
              <li>• <strong>a</strong> book 📚</li>
            </ul>
          </div>
          <div>
            <p className="font-bold text-sage-light mb-1">An → vowel sound</p>
            <ul className="space-y-0.5 text-white/80 text-xs">
              <li>• <strong>an</strong> apple 🍎</li>
              <li>• <strong>an</strong> egg 🥚</li>
              <li>• <strong>an</strong> owl 🦉</li>
              <li>• <strong>an</strong> umbrella ☂️</li>
            </ul>
          </div>
        </div>
      </div>

      <p className="text-center text-[10px] text-white/50 mt-3 italic">Tap a vowel to hear it!</p>
    </div>
  );
}
